import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../../shared/context/global.context";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import { getComercioById } from "../Services/comercio.service";
import { apiSetComercios } from "../../shared/services/comercio.service";
import { consultarComerciosDeUsuario, getVerificar } from "../../shared/services/verificarCarga.service";
import { HttpStatusCode } from "axios";
import { PrivateRoutes } from "../../shared/models/routes";

interface IState {
  enable: boolean;
  user: string;
  userLabel: string;
  users?: users[];
}

interface IProps {
  enviarComercios: Function;
}

interface users {
  login: string;
  nombre: string;
  apellido: string;
  email: string;
  value: string;
  label: string;
}

const BuscarComercio = () => {
  const {
    setComercioSelecionado,
    comercioSelecionado,
    setUsers,
    verificarCarga,
    setBuscarComercio
  } = useGlobalContext();

  const [comercioEncontrado, setComercioEncontrado] = useState<any[]>([]);
  const [idComercio, setIdComercio] = useState<string>('');
  const [loaderBtn, setLoaderBtn] = useState(false);
  const [foundComercio, setFoundComercio] = useState(false);
  const [searching, setSearching] = useState(false);
  const [redirectPage, setRedirectPage] = useState<boolean>(false);

  const [state, setState] = useState<IState>({
    enable: true,
    userLabel: "",
    user: "",
  });
  const toast = useRef<Toast>(null);
  let history = useHistory();

  useEffect(() => {
    if (redirectPage) {
      history.push(PrivateRoutes.HOME);
    }
  }, [redirectPage]);

  const onChange = (e: any) => {
    setIdComercio(e.target.value);
  };

  const searchComercio = async () => {
    if (window.location.href.indexOf("CambiarComercio") > 0) {
      const { data, status } = await consultarComerciosDeUsuario()

      if (!verificarCarga.todos && (data.comerciosString.split(',').length >= 1)) {
        let comerciosList = data.comerciosString.split(',')
        let comercioFound = comerciosList.filter((item: any) => item == idComercio)
        if (comercioFound.length === 0) {
          toast.current?.show({
            life: 5000,
            severity: "error",
            summary: "Message",
            detail: `El comercio ingresado no está asociado al usuario.`,
          });
          return

        }
      }
    }
    if (verificarCarga.comerciosString === "" && !verificarCarga.todos) {
      toast.current?.show({
        life: 5000,
        severity: "error",
        summary: "Message",
        detail: `El usuario no tiene comercios asociados`,
      });
      return
    }
    if ((verificarCarga.comerciosString.split(',').length > 1)) {
      let comerciosList = verificarCarga.comerciosString.split(',')
      let comercioFound = comerciosList.filter((item: any) => item == idComercio)
      if (comercioFound.length === 0) {
        toast.current?.show({
          life: 5000,
          severity: "error",
          summary: "Message",
          detail: `El comercio ingresado no está asociado al usuario.`,
        });
        return

      }
    }
    if (idComercio) {
      setLoaderBtn(true);
      const { data, status } = await getComercioById(idComercio);
      if (status === HttpStatusCode.Ok) {
        if (data.comercios.length === 0) {
          toast.current?.show({
            life: 5000,
            severity: "error",
            summary: "Message",
            detail: `El Comercio ${idComercio} no existe`,
          });
          setFoundComercio(false);
        } else {
          setFoundComercio(true);
          setComercioEncontrado(data.comercios);
        }
      }
      else if (status === HttpStatusCode.BadRequest) {
        toast.current?.show({
          life: 5000,
          severity: "error",
          summary: "Message",
          detail: `El Comercio ${idComercio} no existe`,
        });
        setFoundComercio(false);
      }
      else {
        toast.current?.show({
          life: 5000,
          severity: "error",
          summary: "Message",
          detail: "Se produjo un error vuelve a intentarlo",
        });
      }
      setLoaderBtn(false);
    } else {
      toast.current?.show({
        life: 5000,
        severity: "error",
        summary: "Message",
        detail: "Comercio inválido. Por favor, ingresalo nuevamente.",
      });
    }
  };

  const keyEnter = (e: any) => {
    if (e.key === "Enter") {
      searchComercio();
    }
  };

  const setComercios = async () => {
    setSearching(true);
    const { data, status } = await apiSetComercios({ value: idComercio })
    if (status === 200) {
      setSearching(false);
      setComercioSelecionado(comercioEncontrado);
      setUsers(data.usuarios);
      setRedirectPage(true);
      setBuscarComercio(false)
    }
  }

  return (
    <div className="card">
      <Toast ref={toast} position="bottom-right" />
      <div className="card-container yellow-container">
        <div className="card">
          <div className="grid">
            <div className="col-4 md:col-4 info-container">
              <span>Empresa Activa:</span>
              {comercioSelecionado.length === 0 ? (
                <></>
              ) : (
                <div>
                  <br />
                  <span>
                    {" "}
                    {comercioSelecionado.length > 0
                      ? comercioSelecionado[0].comercioId
                      : ""}
                  </span>
                  <br />
                  <span>
                    {" "}
                    {comercioSelecionado.length > 0
                      ? comercioSelecionado[0].nombreFantasia
                      : ""}
                  </span>
                  <br />
                  <span>
                    {" "}
                    {comercioSelecionado.length > 0
                      ? comercioSelecionado[0].razonSocial
                      : ""}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="search-comercio">
                <label>Ingrese el Comercio: </label>
                <input
                  value={idComercio}
                  type="number"
                  onChange={(e) => onChange(e)}
                  onKeyPress={(e) => keyEnter(e)}
                />
                <Button
                  disabled={searching}
                  label="Buscar Comercio"
                  type="button"
                  className="btn btn-aceptar"
                  loading={loaderBtn}
                  loadingIcon={<i className="pi pi-spin pi-spinner"></i>}
                  iconPos="right"
                  onClick={() => searchComercio()}
                />
                <span>
                  {
                    (foundComercio &&
                    comercioEncontrado.length > 0 &&
                    comercioEncontrado[0]?.razonSocial !== null)
                      ? `* ${comercioEncontrado[0].razonSocial}`
                      : " "
                  }
                </span>
              </div>
            </div>

            <div className="col-4 md:col-4">
              {foundComercio && (
                <div className="mt-4">
                  <Button
                    label="Aceptar"
                    type="button"
                    className="btn btn-aceptar btn-block mt-4"
                    loading={searching}
                    loadingIcon={<i className="pi pi-spin pi-spinner"></i>}
                    iconPos="right"
                    onClick={setComercios}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="block  font-bold text-center p-4 border-round mb-3"></div>
      </div>
    </div>
  );
};
export default BuscarComercio;
